import {i18nModule} from "@config/i18n.module";
import {NgModule} from "@angular/core";
import {HttpModule} from "@angular/http";
import {CommonModule} from "@angular/common";
import {ResourcesModule} from "@resources/resources.module";
import {FlexLayoutModule} from "@angular/flex-layout";
import {ResourceMultimediaPipe} from "./image/resource.multimedia.pipe";
import {DigiCerbaCommonModule} from "@digicerba/common";
import {ResourceTemplatePipe} from "./template/resource.template.pipe";
import {ResourceIconPipe} from "./icons/resource.icone.pipe";
// Form
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

/** liste des components / directive à exporter */
var sharedDeclaration: Array<any> = [
  ResourceMultimediaPipe, ResourceTemplatePipe, ResourceIconPipe,
];

/** liste des modules à exporter */
var sharedModules: Array<any> = [
  FormsModule, ReactiveFormsModule, CommonModule, ResourcesModule, FlexLayoutModule, i18nModule
];

/** Liste des composants interne au module */
var declarations: Array<any> = [
];

/** Liste des services */
var services: Array<any> = [
];

/** Liste des composants necessitant la création d'une factory */
var entryComponents: Array<any> = [
];

@NgModule({
  imports: [DigiCerbaCommonModule.forRoot(), HttpModule, ...sharedModules],
  declarations: [...sharedDeclaration, ...declarations, ...entryComponents],
  exports: [DigiCerbaCommonModule, ...sharedDeclaration, ...sharedModules],
  providers: services,
  entryComponents: entryComponents
})
export class UtilsModule { }



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/common/utils/utils.module.ts